// Shared sector data — used both by the Landing teaser and the Sectors page.
import {
    Zap, HeartPulse, Wheat, Building, Briefcase, Pickaxe, HandHeart,
    GraduationCap, Droplets, Truck, Building2, CreditCard, Factory, Cpu,
} from 'lucide-react';

// All 14 sectors share the SAME shape (icon, emoji, name, pitch, long, bullets)
// so both Landing and /p/secteurs can render them uniformly.
export const SECTORS_ALL = [
    {
        key: 'energie', icon: Zap, emoji: '⚡', name: 'Énergie',
        pitch: 'Solaire, hydro, thermique : du gisement à l\'exploitation.',
        long: 'Pilotez vos projets énergétiques de l\'étude de gisement à l\'exploitation commerciale, en cohérence avec les exigences ARSEL/ARSE et les standards bailleurs (BAD, BEI, AFD, IFC).',
        bullets: [
            'Étude de gisement & faisabilité',
            'EIES & permis environnementaux',
            'Bouclage financier & PPP',
            'KPI exploitation temps réel',
        ],
    },
    {
        key: 'sante', icon: HeartPulse, emoji: '🏥', name: 'Santé',
        pitch: 'Hôpitaux, programmes de santé publique, équipements.',
        long: 'Coordonnez vos programmes de santé, vos équipements médicaux et vos campagnes de prévention en alignement avec les exigences OMS, GAVI et Fonds mondial.',
        bullets: [
            'Diagnostic des besoins terrain',
            'Acquisition & installation équipements',
            'Formation du personnel médical',
            'Suivi & évaluation indicateurs santé',
        ],
    },
    {
        key: 'agriculture', icon: Wheat, emoji: '🌾', name: 'Agriculture',
        pitch: 'Coopératives, transformation, subventions agricoles.',
        long: 'Structurez vos filières agricoles : du diagnostic agronomique à la commercialisation, en passant par les subventions FAO, IFAD et les financements à impact.',
        bullets: [
            'Plan d\'aménagement parcellaire',
            'Financement intrants & équipements',
            'Traçabilité Bio / Fair Trade',
            'Indicateurs ODD 2 (faim zéro)',
        ],
    },
    {
        key: 'infrastructure', icon: Building, emoji: '🏗️', name: 'Infrastructure',
        pitch: 'Routes, ouvrages d\'art, bâtiments publics.',
        long: 'Pilotez vos chantiers d\'infrastructure publique avec une couverture complète : 9 phases de l\'APS à la garantie d\'achèvement, conformité bailleurs, audit qualité.',
        bullets: [
            'APS / APD / Mandat structurés',
            'Suivi chantier & avancement physique',
            'GED réglementaire conforme',
            'Réception & garantie décennale',
        ],
    },
    {
        key: 'services', icon: Briefcase, emoji: '💼', name: 'Services',
        pitch: 'Conseil, consulting, opérations clients.',
        long: 'Orchestrez vos missions de conseil et vos opérations clients : du cadrage des besoins à la livraison, avec un suivi qualité et un reporting transparent.',
        bullets: [
            'Cadrage & contractualisation',
            'Mobilisation des équipes',
            'Suivi qualité & SLA',
            'Bilan & capitalisation',
        ],
    },
    {
        key: 'mines', icon: Pickaxe, emoji: '⛏️', name: 'Mines',
        pitch: 'Prospection, exploitation, réhabilitation.',
        long: 'De la prospection à la réhabilitation du site : maîtrisez vos permis miniers, votre EIES, votre exploitation et votre clôture environnementale aux standards internationaux.',
        bullets: [
            'Permis miniers & environnement',
            'Suivi exploitation & production',
            'HSE et conformité ICMM',
            'Réhabilitation & clôture site',
        ],
    },
    {
        key: 'ong', icon: HandHeart, emoji: '🤝', name: 'ONG / Associatif',
        pitch: 'Programmes humanitaires & développement.',
        long: 'Pilotez vos programmes humanitaires et de développement avec un reporting bailleurs irréprochable, des indicateurs ODD natifs et une capitalisation projet par projet.',
        bullets: [
            'Identification & diagnostic terrain',
            'Recherche multi-bailleurs',
            'Suivi-évaluation indicateurs ODD',
            'Capitalisation & redevabilité',
        ],
    },
    {
        key: 'education', icon: GraduationCap, emoji: '🎓', name: 'Éducation',
        pitch: 'Écoles, universités, formation professionnelle, e-learning et programmes bailleurs.',
        long: 'Pilotez vos cohortes, vos curricula et vos décaissements bailleurs en cohérence avec les standards CAMES et les certifications professionnelles internationales.',
        bullets: [
            'Pilotage de cohortes & inscription en ligne',
            'Suivi pédagogique individualisé',
            'Reporting bailleurs (BAD, AFD, UE)',
            'Certifications RNCP / CAMES',
        ],
    },
    {
        key: 'eau', icon: Droplets, emoji: '💧', name: 'Eau & Assainissement',
        pitch: 'Projets publics, ONG et infrastructures à fort impact social.',
        long: 'GED conformité, suivi multi-bailleurs et indicateurs ODD intégrés pour les projets d\'adduction d\'eau, d\'assainissement et d\'hygiène.',
        bullets: [
            'Étude hydrogéologique structurée',
            'Conformité Performance Standards SFI',
            'Indicateurs ODD 6 (eau & assainissement)',
            'Comités locaux de gestion',
        ],
    },
    {
        key: 'logistique', icon: Truck, emoji: '🚛', name: 'Logistique & Transport',
        pitch: 'Corridors logistiques, ports, rail, supply chain et mobilité urbaine.',
        long: 'Coordination multi-acteurs et reporting investisseurs en temps réel. Articulation native avec les régulateurs douaniers et les opérateurs portuaires.',
        bullets: [
            'Cartographie des flux & goulots',
            'Montage PPP & SPV',
            'Tableau de bord investisseurs',
            'KPI carbone (CO₂ / t-km)',
        ],
    },
    {
        key: 'immobilier', icon: Building2, emoji: '🏠', name: 'Immobilier & Construction',
        pitch: 'Projets immobiliers, smart cities, bâtiments publics, habitat et urbanisme.',
        long: 'Suivi chantier, GED réglementaire et reporting trimestriel investisseurs. De l\'audit foncier à la garantie décennale.',
        bullets: [
            'Audit foncier & purge des droits',
            'VEFA, GFA, appels de fonds',
            'Plan HSE & taux de fréquence',
            'Reporting investisseurs trimestriel',
        ],
    },
    {
        key: 'fintech', icon: CreditCard, emoji: '💳', name: 'Fintech & Inclusion financière',
        pitch: 'Mobile Money, microfinance, paiements et digitalisation financière.',
        long: 'KYC, conformité AML/CFT, suivi des flux multi-devises et intégration aux switchs nationaux (GIM-UEMOA, NIBSS) et aux banques partenaires.',
        bullets: [
            'KYC tiers (lite / full / business)',
            'Screening sanctions OFAC & UE',
            'Intégrations switchs nationaux',
            'Conformité Bâle, GAFI, RGPD',
        ],
    },
    {
        key: 'industrie', icon: Factory, emoji: '🏭', name: 'Industrie & Transformation locale',
        pitch: 'Transformation des matières premières, agro-industrie, industrialisation continentale.',
        long: 'Sécurisation amont, conformité HACCP/ISO 22000, FAT et pilotage OEE pour des unités industrielles aux standards internationaux.',
        bullets: [
            'Contractualisation matière première',
            'Permis ICPE & EIE',
            'HACCP / ISO 22000',
            'Indicateurs OEE temps réel',
        ],
    },
    {
        key: 'smartcity', icon: Cpu, emoji: '🌆', name: 'Smart Cities & Territoires',
        pitch: 'Villes intelligentes, gouvernance territoriale, data urbaine et infrastructures numériques.',
        long: 'Pilotage data-driven aligné sur la vision African Valley · IA · Data. De la stratégie politique à la plateforme urbaine déployée.',
        bullets: [
            'Schéma directeur urbain numérique',
            'Plateforme FIWARE / OGC',
            'Charte éthique de la donnée',
            'Indicateurs ODD 11',
        ],
    },
];

// Backward-compat exports (some older imports may still reference them)
export const SECTORS_FOUNDING = SECTORS_ALL.slice(0, 7);
export const SECTORS_NEW = SECTORS_ALL.slice(7);
